export const TEXT_RESOLUTION = Math.min(window.devicePixelRatio, 2);
